import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const createDynamicAgentGroupService = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.SMART_CONNECT}/createDynamicAgentGroup`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error in createDynamicAgentGroup service : ", err);
    return (
      err?.response?.data || {
        success: false,
        message: "Internal Server Error",
        data: null,
      }
    );
  }
};

export const updateAgentGroupStatus = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.SMART_CONNECT}/updateAgentGroupStatus`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error in updateAgentGroupStatus service : ", err);
    return (
      err?.response?.data || {
        success: false,
        message: "Internal Server Error",
        data: null,
      }
    );
  }
};

export const fetchDynamicAgentGroupsService = async () => {
  try {
    const token = getToken();
    const response = await apiService.get(
      `${API_URL.SMART_CONNECT}/fetchAllAgentGroups`,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error in fetchDynamicAgentGroupsService service : ", err);
    return (
      err?.response?.data || {
        success: false,
        message: "Internal Server Error",
        data: null,
      }
    );
  }
};

export const fetchDynamicAgentGroupList = async (body) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.SMART_CONNECT}/fetchDynamicGroupAgentList`,
      body,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error in fetchDynamicAgentGroupList service : ", err);
    return (
      err?.response?.data || {
        success: false,
        message: "Internal Server Error",
        data: null,
      }
    );
  }
};

export const addNewAgentsInDynamicGroup = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.SMART_CONNECT}/addNewAgentsInDynamicGroup`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error in addNewAgentsInDynamicGroup service : ", err);
    return (
      err?.response?.data || {
        success: false,
        message: "Internal Server Error",
        data: null,
      }
    );
  }
};


export const manualDidAssignInitiate = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.SMART_CONNECT}/manualDidAssignInitiate`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error in addNewAgentsInDynamicGroup service : ", err);
    return (
      err?.response?.data || {
        success: false,
        message: "Internal Server Error",
        data: null,
      }
    );
  }
};
